<template>
	<div class="flex flex-col md:flex-row justify-between">
		<div class="w-full md:w-2/5">
			<p class="mb-2">{{ $t('available') }}:</p>
			<ul
				class="h-64 overflow-y-scroll p-4 border border-solid border-inputGrey"
			>
				<li class="py-1" v-for="item in options.items" :key="item.id">
					<span
						class="cursor-pointer"
						v-on:click="transferToRight(options.items.indexOf(item))"
					>
						{{ item.name }}</span
					>
				</li>
			</ul>
		</div>

		<div class="flex flex-col justify-center items-center">
			<div>
				<button class="my-5" @click="allToRight()">
					<span class="cursor-pointer text-black flex">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 320 512"
							class="text-bold fill-current h-3"
						>
							<path
								d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
							></path>
						</svg>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 320 512"
							class="text-bold fill-current h-3"
						>
							<path
								d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
							></path>
						</svg>
					</span>
				</button>
			</div>

			<div>
				<button class="my-5" @click="allToLeft()">
					<span class="cursor-pointer text-black flex">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 320 512"
							class="text-bold rotate180 fill-current h-3"
						>
							<path
								d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
							></path>
						</svg>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 320 512"
							class="text-bold rotate180 fill-current h-3"
						>
							<path
								d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
							></path>
						</svg>
					</span>
				</button>
			</div>
		</div>

		<div class="w-full md:w-2/5">
			<p class="mb-2">{{ $t('selected') }}:</p>
			<ul
				class="h-64 overflow-y-scroll p-4 border border-solid border-inputGrey"
			>
				<li class="py-1" v-for="item in options.selectedItems" :key="item.id">
					<span
						class="cursor-pointer"
						v-on:click="transferToLeft(options.selectedItems.indexOf(item))"
					>
						{{ item.name }}
					</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		options: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			item: {}
		}
	},
	created() {
		this.options.items.sort(this.compare)
		this.options.selectedItems.sort(this.compare)
	},
	methods: {
		getCountryName(countryId) {
			const languages = ['ES', 'PT', 'IT']
			return languages[countryId - 1]
		},
		transferToRight(index) {
			if (index >= 0) {
				this.options.selectedItems.push(this.options.items[index])
				this.options.items.splice(index, 1)
			} else {
				for (var cont = 0; cont < this.options.items.length; cont++) {
					this.options.selectedItems.push(this.options.items[cont])
				}

				this.options.items.splice(0, this.options.items.length)
			}
			this.options.selectedItems.sort(this.compareRol)
			this.options.items.sort(this.compareRol)
		},
		transferToLeft(index) {
			if (index >= 0) {
				this.options.items.push(this.options.selectedItems[index])
				this.options.selectedItems.splice(index, 1)
				return
			}
			for (var cont = 0; cont < this.options.selectedItems.length; cont++) {
				this.options.items.push(this.options.selectedItems[cont])
			}
			this.options.selectedItems.splice(0, this.options.selectedItems.length)
			this.options.items.sort(this.compareRol)
			this.options.selectedItems.sort(this.compareRol)
		},
		allToRight() {
			this.options.selectedItems = [
				...this.options.selectedItems,
				...this.options.items
			]
			this.options.items = []
			this.options.selectedItems.sort(this.compareRol)
		},
		allToLeft() {
			this.options.items = [
				...this.options.selectedItems,
				...this.options.items
			]
			this.options.selectedItems = []
			this.options.items.sort(this.compareRol)
		},
		compare(a, b) {
			// Use toUpperCase() to ignore character casing
			const A = a.name.toUpperCase()
			const B = b.name.toUpperCase()

			let comparison = 0
			if (A > B) {
				comparison = 1
			} else if (A < B) {
				comparison = -1
			}
			return comparison
		}
	}
}
</script>
<style scoped>
.rotate180 {
	-moz-transform: rotate(-180deg);
	-o-transform: rotate(-180deg);
	-webkit-transform: rotate(-180deg);
	transform: rotate(-180deg);
}
</style>
